import { hot } from 'react-hot-loader/root';
import Component from './signup-redux';

export default hot(Component);
